import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputHelperTextComponent } from 'app/shared/components/input-helper-text/input-helper-text.component';
import { HelperService } from 'app/shared/services/helper.service';
import { BsDatepickerModule, BsDaterangepickerConfig } from 'ngx-bootstrap/datepicker';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-daterangepicker-form-field',
  standalone: true,
  imports: [CommonModule, TranslateModule, ReactiveFormsModule, BsDatepickerModule, InputHelperTextComponent],
  templateUrl: './daterangepicker-form-field.component.html',
  styleUrl: './daterangepicker-form-field.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DaterangepickerFormFieldComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => DaterangepickerFormFieldComponent),
      multi: true,
    }
  ],
})

export class DaterangepickerFormFieldComponent implements ControlValueAccessor, OnInit, OnDestroy {
  @Input() label: string = '';
  @Input() placeholder: string = 'placeholders.please_select';
  @Input() isRequired: boolean = false;
  @Input() infoText: string = '';
  @Input() minDate!: Date;
  @Input() maxDate!: Date;
  @Input() helpText!: string;

  formControl: FormControl = new FormControl<[Date | null, Date | null]>([null, null]);
  errorText: string = '';

  bsConfig: Partial<BsDaterangepickerConfig> = {
    isAnimated: true,
    rangeInputFormat: 'YYYY-MM-DD',
    containerClass: 'theme-default',
    adaptivePosition: true,
  };

  private unsubscribe$ = new Subject<void>();

  onTouch: () => void = () => { };
  onChange: (value: any) => void = () => { };

  constructor(
    private helperService: HelperService
  ) { }

  ngOnInit(): void {
    this.formControl.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
      value = (value as Array<string | null>).map(v => this.helperService.convertToMidnightUTC(v));
      this.onChange(value);
    });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    isDisabled ? this.formControl.disable() : this.formControl.enable();
  }

  writeValue(value: [string | null, string | null] | null): void {
    if (value && Array.isArray(value)) {
      const [from, to] = value;

      this.formControl.setValue([
        from ? new Date(from) : undefined,
        to ? new Date(to) : undefined
      ], { emitEvent: false });

    } else {
      this.formControl.setValue([undefined, undefined], { emitEvent: false });
    }
  }


  validate(control: FormControl) {
    setTimeout(() => {
      this.errorText = this.helperService.handleFieldsErrors(control);
    });
    return null;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
